import React, { ReactElement } from 'react'
import { Helmet } from 'react-helmet'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import ThemeBase from '../components/ThemeBase'
import AppBar from '../components/AppBar'
import Title from '../components/Title'
import CloseButton from '../components/CloseButton'
import useHideCloseButton, { shouldHideCloseButton } from '../hooks/useHideCloseButton'
import { closeIframe } from '../services/iframe/iframeHelper'
import { printConfig } from '../../config'

const useStyles = makeStyles(theme => ({
  container: {
    paddingBottom: theme.spacing(3)
  }
}))

interface LayoutProps {
  gameName: string
  children: ReactElement | ReactElement[]
}

function Layout({ gameName, children }: LayoutProps): ReactElement {
  const classes = useStyles()
  const isCloseButtonHidden = useHideCloseButton()
  return (
    <ThemeBase>
      <Helmet htmlAttributes={{ lang: 'en' }}>
        <meta charSet="utf-8" />
        <meta name="description" content="Helpfiles for your game" />
        <title>{gameName}</title>
      </Helmet>
      <AppBar>
        <Title
          title={gameName}
          printFontSize={printConfig.mainHeading.fontSize}
          printBottomBorder={true}
          variant="body1"
        />
        <CloseButton hidden={isCloseButtonHidden} onClick={closeIframe} />
      </AppBar>
      <Container maxWidth="md">
        <div className={classes.container}>{children}</div>
      </Container>
    </ThemeBase>
  )
}

export default Layout
